import {AfterViewInit, Component, Input, OnInit} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import * as mapboxgl from 'mapbox-gl';
import {ActivatedRoute} from '@angular/router';
import {document} from 'ngx-bootstrap/utils';
import {UserService} from '../../../../services/user-services/user.service';
import {TranslateModule} from '@ngx-translate/core';
import {IconComponent} from '../../icons-svgs/icons-svgs.component';
import {NgxIntlTelInputModule} from '@justin-s/ngx-intl-tel-input';
import {FormsModule} from '@angular/forms';
import {MatChipsModule} from '@angular/material/chips';
import {NgClass, NgFor, NgIf} from '@angular/common';
import {PlatformService} from '../../../../services/platform-service.service';

@Component({
    selector: 'app-accommodation-map',
    templateUrl: './accommodation-map.component.html',
    styleUrls: ['./accommodation-map.component.scss'],
    standalone: true,
    imports: [NgClass, NgIf, MatChipsModule, FormsModule, NgxIntlTelInputModule, NgFor, IconComponent, TranslateModule]
})
export class AccommodationMapComponent implements OnInit, AfterViewInit {

  @Input() room;
  @Input() embassyCenter;
  public currentId: string;
  public map: mapboxgl.Map;
  public style = 'mapbox://styles/mapbox/streets-v12';
  public draw;
  public center;
  public markers = [];
  public startCoordonates;
  public destinationCoordonates;
  public results = null;
  public place = null;
  public open = false;
  public userLang = 'en';
  public currentSearch;
  public currentResult;
  public showMatChip: boolean = false;
  public hours;
  public minutes;
  public type;
  public driving;
  public cycling;
  public walking;
  public isMobile = false;

  constructor(
    private route: ActivatedRoute,
    private http: HttpClient,
    private userService: UserService,
    private platformService : PlatformService
  ) { }

  ngOnInit(): void {
    if(this.platformService.isBrowserPlatform()){
      this.isMobile = this.userService.isMobileUser;
      this.currentId = this.route.snapshot.paramMap.get('id');
      if(this.embassyCenter){
        this.center = this.embassyCenter;
      }
      else {
        this.center = [ this.room.property_address.longitude , this.room.property_address.latitude];
      }
    }

  }

  ngAfterViewInit() {
    if(this.platformService.isBrowserPlatform()) {

      mapboxgl as typeof mapboxgl;
      this.map = new mapboxgl.Map({
        accessToken:
            'pk.eyJ1IjoiZG9vbWl0aCIsImEiOiJjbGx1dnRjdmYxN2diM2tvNzkwaGEyaWF2In0.iHZiLIVgE6wJyy_Q5NdR5g',
        container: 'map',
        style: this.style,
        zoom: 14,
        scrollZoom: false,
        center: this.center,
      });
      this.map.dragRotate.disable();
      this.map.touchZoomRotate.disableRotation();
      this.map.addControl(new mapboxgl.NavigationControl({
        showCompass: false
      }), 'bottom-right');
      this.map.setCenter(this.center);
      this.setMarker();
    }
  }

  setMarker() {
    if(this.platformService.isBrowserPlatform()) {
      const el = document.createElement('div');
      el.className = 'marker';

      /*
      Voir le commentaire en dessous
      this.draw = new MapboxDraw({
        displayControlsDefault: false,
        controls: {
          line_string: true,
          trash: true
        },
        styles: [
          {
            "id": "gl-draw-line",
            "type": "line",
            "filter": ["all", ["==", "$type", "LineString"], ["!=", "mode", "static"]],
            "layout": {
              "line-cap": "round",
              "line-join": "round"
            },
            "paint": {
              "line-color": "#3b9ddd",
              "line-dasharray": [0.2, 2],
              "line-width": 4,
              "line-opacity": 0.7
            }
          },
          {
            "id": "gl-draw-polygon-and-line-vertex-halo-active",
            "type": "circle",
            "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
            "paint": {
              "circle-radius": 10,
              "circle-color": "#FFF"
            }
          },
          {
            "id": "gl-draw-polygon-and-line-vertex-active",
            "type": "circle",
            "filter": ["all", ["==", "meta", "vertex"], ["==", "$type", "Point"], ["!=", "mode", "static"]],
            "paint": {
              "circle-radius": 6,
              "circle-color": "#3b9ddd",
            }
          },
        ]
      });*/

      if (!this.embassyCenter) {
        // En commentaire parce qu'il semble pas servir mais faut tester & tester pour être sûr avant de supprimer totalement
        // this.map.addControl(this.draw);
        let newContent = '';
        newContent = document.createTextNode(Math.ceil(this.room.price) + ' €');
        new mapboxgl.Marker(el).setLngLat([this.room.property_address.longitude, this.room.property_address.latitude]).addTo(this.map);
        this.center = [this.room.property_address.longitude, this.room.property_address.latitude];
        el.appendChild(newContent);
      }

      this.map.setCenter(this.center);
      this.startCoordonates = this.center;
    }
  }

  getRoutes(){
    if(this.platformService.isBrowserPlatform()) {

      this.showMatChip = true;
      this.driving = this.createRoute('driving');
      this.walking = this.createRoute('walking');
      this.cycling = this.createRoute('cycling');
    }
  }

  createRoute(mode) {
    if(this.platformService.isBrowserPlatform()) {

      this.type = mode;
      if (this.destinationCoordonates) {
        this.eraseLayer();
        const directionsRequest = 'https://api.mapbox.com/directions/v5/mapbox/' + mode + '/' +
            `${this.startCoordonates};${this.destinationCoordonates}` +
            '?steps=true&geometries=geojson&overview=full&access_token=' + 'pk.eyJ1IjoiZG9vbWl0aCIsImEiOiJjbGx1dnRjdmYxN2diM2tvNzkwaGEyaWF2In0.iHZiLIVgE6wJyy_Q5NdR5g';

        fetch(directionsRequest)
            .then(response => response.json())
            .then(data => {
              if (data.code === 'Ok') {
                const route = data.routes[0].geometry;
                const info = data.routes[0];

                const s = new mapboxgl.Marker()
                    .setLngLat(this.destinationCoordonates)
                    .addTo(this.map);

                this.markers.push(s);


                switch (mode) {
                  case 'walking' : {
                    this.walking = info;
                    break;
                  }
                  case 'driving' : {
                    this.driving = info;
                    break;
                  }
                  case 'cycling' : {
                    this.map.addLayer({
                      id: 'route',
                      type: 'line',
                      source: {
                        type: 'geojson',
                        data: {
                          type: 'Feature',
                          properties: {},
                          geometry: route
                        }
                      },
                      layout: {
                        'line-join': 'round',
                        'line-cap': 'round'
                      },
                      paint: {
                        'line-color': '#002FA7',
                        'line-width': 8,
                        'line-opacity': 0.75
                      }
                    });

                    this.cycling = info;
                    const bounds = new mapboxgl.LngLatBounds()
                        .extend(this.startCoordonates)
                        .extend(this.destinationCoordonates);
                    this.map.fitBounds(bounds, {padding: 20});


                    break;
                  }
                }
              }
            });
      }
    }
  }

  doSearch(search)
  {
    if(this.platformService.isBrowserPlatform()) {

      if (search.target.value.length >= 3) {
        this.open = true;
        this.currentResult = null;
        const url = 'https://api.mapbox.com/search/searchbox/v1/suggest?q=' + search.target.value + '&types=region%2Cpostcode%2Clocality%2Cpoi%2Cdistrict%2Caddress%2Cstreet%2Cplace&language=' + this.userLang + '&session_token=0cf038c5-bdb9-4868-818a-93ec98530089&access_token=pk.eyJ1IjoiZG9vbWl0aCIsImEiOiJjbGx1dnF0ejAxankzM2VucWhyazdsZmpsIn0.rjVmbaTbECn0UYo0iS7_nQ';
        this.http.get(url).subscribe(datas => {
          this.results = datas;
        });

      } else {
        this.open = false;
      }
    }
  }


  getPlaceInformations(m_id,name){
    if(this.platformService.isBrowserPlatform()) {

      this.open = false;
      const url = 'https://api.mapbox.com/search/searchbox/v1/retrieve/' + m_id + '?session_token=0cf038c5-bdb9-4868-818a-93ec98530089&access_token=pk.eyJ1IjoiZG9vbWl0aCIsImEiOiJjbGx1dnF0ejAxankzM2VucWhyazdsZmpsIn0.rjVmbaTbECn0UYo0iS7_nQ';
      this.http.get(url).subscribe(datas => {
        this.place = datas;
        this.destinationCoordonates = this.place.features[0].geometry.coordinates;
        this.currentSearch = name;
        this.currentResult = name;
        this.getRoutes();
        this.currentSearch = '';

      });
    }
  }

  colorResult(str) {
    const k = this.currentSearch.trim();
    const regex = k.replace(/\s+/g, '-').toLowerCase();
    const string = str.replace(/\s+/g, '-').toLowerCase();
    const tmpString = string.normalize('NFD').replace(/[\u0300-\u036f]/g, '');
    const tmpRegex = regex.normalize('NFD').replace(/[\u0300-\u036f]/g, '');

    if(tmpString.includes(tmpRegex)){
      let result = '';
      result = tmpString.replace(regex, '<span class="highlight">' + regex + '</span>');

       if(tmpString === result){
         result = string.replace(regex, '<span class="highlight">' + regex + '</span>');
       }
      return result.replace(/-/gi, ' ');
    }
    return str;
  }

  reset(){
    this.currentSearch = null;
    this.results = [];
    this.open = false;
    this.showMatChip = false;
    this.eraseLayer();
    this.destinationCoordonates = null;
  }


  eraseLayer(){
    this.markers.forEach(element => {
      element.remove();
    });
    if (this.map.getLayer('route')) {
      this.map.removeLayer('route');
    }
    if (this.map.getSource('route')) {
      this.map.removeSource('route');
    }
  }

  getMinutes(duration){
    return Math.floor((duration % 3600) / 60);
  }

  getHours(duration){
    return Math.floor(duration / 3600);
  }

  getDistance(distance){
    return Math.ceil((distance / 1000) * 100) / 100;
  }



}
